export default "__VITE_ASSET__DYR9AHAl__"